import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'grecoTimestamp' })
export class TimestampPipe implements PipeTransform {
  transform(value: { _seconds: number }): Date {
    return new Date(value._seconds * 1000);
  }
}
